import strategy from './strategy';
import Link from './components/Link';

const linkAsAWordPlugin = {
    strategy,
    component: Link,
};

export default linkAsAWordPlugin;
